"use strict";
import axios from "axios";
import i18n from "../i18n";


export function get_province(country_id) {
    const formData = new FormData();
    formData.append('CountryId', country_id);
    return axios.post('public/GetCities', formData, {}).then(function (response) {
        return response
    }).catch(function (error) {
            console.log(error);
    });
}

function sort_array(fabric_array, unsorted, id_key, label_key) {
    var tmpAry = new Array();

    for (var i = 0; i < unsorted.length; i++) {
        // tmpAry[i] = {value:unsorted[i][id_key],label:unsorted[i][label_key]}
        tmpAry[i] = unsorted[i];
        tmpAry[i].value = unsorted[i][id_key];
        tmpAry[i].label = unsorted[i][label_key];

    }
    // console.log(tmpAry)
    tmpAry.sort((a, b) => a.label.localeCompare(b.label, undefined, {numeric: true, sensitivity: 'base'}));

    fabric_array.push(...tmpAry)
    return fabric_array;

}

export function get_places() {
    const formData = new FormData();
    return axios.post('GetPlaces', formData, {}).then(function (response) {

        let places =[]
        response.data.data.forEach((val) => {
            var obj = {label: val.placeName, value: val.id}
            places.push(obj)
        });
        return places
    }).catch(function (error) {
            console.log(error);
    });
}
export function get_cats() {
    const formData = new FormData();
    return axios.post('GetCats', formData, {}).then(function (response) {
        let category_items = [];
        var obj = {label: i18n.t('all'), value: 0}
        category_items.push(obj);
        category_items = sort_array(
            category_items, response.data.data,
            'recId', 'catTitle');
        return category_items
    }).catch(function (error) {
            console.log(error);
    });
}
export function get_brands(default_brand_title=i18n.t('noBrand')) {
    const formData = new FormData();
    return axios.post('GetBrands', formData, {}).then(function (response) {


        let brand_items = [{label: default_brand_title, value: 0}];

        brand_items = sort_array(
            brand_items, response.data.data,
            'id', 'brandName');

        return brand_items;

    }).catch(function (error) {
            console.log(error);
    });
}

